export const APPLY_INTL = 'APPLY_INTL';

export const FETCH_ENTITY_TYPE = 'FETCH_ENTITY_TYPE';
export const SET_ENTITY_TYPE_LIST = 'SET_ENTITY_TYPE_LIST';
export const SET_PREFERENCE_SETTING = "SET_PREFERENCE_SETTING";
export const SET_ALL_PREFERENCE_SETTING = "SET_ALL_PREFERENCE_SETTING";
export const SET_PREFERENCES_CONTENT = "SET_PREFERENCES_CONTENT";
export const SET_PREFERENCES_CONTENT_IN_PROGRESS = "SET_PREFERENCES_CONTENT_IN_PROGRESS";

export const SET_CURRENCY_CONTENT = "SET_CURRENCY_CONTENT";
export const SET_CURRENCY_CONTENT_IN_PROGRESS = "SET_CURRENCY_CONTENT_IN_PROGRESS";
export const CLEAR_CURRENCY_CONTENT = "CLEAR_CURRENCY_CONTENT";

export const SET_PRICEBOOK_TAXES = "SET_PRICEBOOK_TAXES";

export const SET_PRIMARY_SUBSIDIARY = "SET_PRIMARY_SUBSIDIARY";
export const SET_COMPANY_PRIMARY_SUBSIDIARY = "SET_COMPANY_PRIMARY_SUBSIDIARY";

export const FETCH_INVENTORY_STATUS = "FETCH_INVENTORY_STATUS";
export const FETCH_TRANSACTION_STATUS = "FETCH_TRANSACTION_STATUS";
export const SET_INVENTORY_TRANSFER = "SET_INVENTORY_TRANSFER";
export const SET_INVENTORY_STATUS_LIST = "SET_INVENTORY_STATUS_LIST";
export const SET_TRANSACTION_STATUS_LIST = "SET_TRANSACTION_STATUS_LIST";
export const SET_DEVICE_STATUS_LIST = "SET_DEVICE_STATUS_LIST";
export const MASS_TRANSFER_IN_PROGRESS = "MASS_TRANSFER_IN_PROGRESS";
export const MASS_TRANSFER_DONE = "MASS_TRANSFER_DONE";
export const CLEAR_INVENTORY_TRANSFER = "CLEAR_INVENTORY_TRANSFER";
export const SET_INVENTORY_TRANSFER_PREFERENCES = "SET_INVENTORY_TRANSFER_PREFERENCES";
export const SET_TRANSFER_FORM_LINE_PAGINATION = "SET_TRANSFER_FORM_LINE_PAGINATION";

export const SET_LIST_TABLE_OPTIONS = 'SET_LIST_TABLE_OPTIONS';

export const CLEAR_DROPDOWN = 'CLEAR_DROPDOWN';
export const CLEAR_DATA_BY_ID = 'CLEAR_DATA_BY_ID';
export const SET_INVENTORY_ADJUSTMENT = 'SET_INVENTORY_ADJUSTMENT';
export const CLEAR_INVENTORY_ADJUSTMENT = 'CLEAR_INVENTORY_ADJUSTMENT';

export const SET_REPORT_DATA_EXPORTS = 'SET_REPORT_DATA_EXPORTS';

export const SET_CURRENT_PATH = 'SET_CURRENT_PATH';

export const DONE_DOWNLOADING_DATA = 'DONE_DOWNLOADING_DATA';
export const IMMEDIATE_DOWNLOAD = 'IMMEDIATE_DOWNLOAD';
export const INITIALIZE_DOWNLOADING_DATA = 'INITIALIZE_DOWNLOADING_DATA';
export const SET_DOWNLOAD_DATA = 'SET_DOWNLOAD_DATA';
export const SEARCH_RECORD_EXPORT_FILE_DOWNLOAD = 'SEARCH_RECORD_EXPORT_FILE_DOWNLOAD';
export const LABEL_PRINT_FILE_DOWNLOAD = 'LABEL_PRINT_FILE_DOWNLOAD';

export const SET_PURCHASE_ORDER = 'SET_PURCHASE_ORDER';
export const CLEAR_PURCHASE_ORDER = 'CLEAR_PURCHASE_ORDER';
export const GENERATE_PURCHASE_RECEIPT = 'GENERATE_PURCHASE_RECEIPT';
export const OPEN_PURCHASE_RECEIPT_REFERENCE_ID_MODAL = 'OPEN_PURCHASE_RECEIPT_REFERENCE_ID_MODAL';

export const SET_PURCHASE_RECEIPT = 'SET_PURCHASE_RECEIPT';
export const CLEAR_PURCHASE_RECEIPT = 'CLEAR_PURCHASE_RECEIPT';
export const GENERATE_PURCHASE_RETURN = 'GENERATE_PURCHASE_RETURN';
export const OPEN_PURCHASE_RETURN_REFERENCE_ID_MODAL = 'OPEN_PURCHASE_RETURN_REFERENCE_ID_MODAL';

export const SET_INVENTORY_RETURN = 'SET_INVENTORY_RETURN';
export const CLEAR_INVENTORY_RETURN = 'CLEAR_INVENTORY_RETURN';

export const SET_INVENTORY_STOCKTAKE = 'SET_INVENTORY_STOCKTAKE';
export const CLEAR_INVENTORY_STOCKTAKE = 'CLEAR_INVENTORY_STOCKTAKE';
export const OPEN_INVENTORY_STOCKTAKE_REFERENCE_ID_MODAL = 'OPEN_INVENTORY_STOCKTAKE_REFERENCE_ID_MODAL';
export const SET_STOCKTAKE_FORM_LINE_PAGINATION = 'SET_STOCKTAKE_FORM_LINE_PAGINATION';
export const SET_STOCKTAKE_PREFERENCES = 'SET_STOCKTAKE_PREFERENCES';

export const SET_ITEM_LOCATION = 'SET_ITEM_LOCATION';
export const CLEAR_ITEM_LOCATION = 'CLEAR_ITEM_LOCATION';
export const OPEN_ITEM_LOCATION_MODAL = 'OPEN_ITEM_LOCATION_MODAL';
export const CLOSE_ITEM_LOCATION_MODAL = 'CLOSE_ITEM_LOCATION_MODAL';
export const VIEW_ITEM_LOCATION_MODAL = 'VIEW_ITEM_LOCATION_MODAL';
export const EDIT_ITEM_LOCATION_MODAL = 'EDIT_ITEM_LOCATION_MODAL';
export const SHOW_APPLY_TO_ALL_STORE_MESSAGE_MODAL = 'SHOW_APPLY_TO_ALL_STORE_MESSAGE_MODAL';
export const PROCESSING_APPLY_TO_ALL_STORE = 'PROCESSING_APPLY_TO_ALL_STORE';
export const SET_ITEM_LOCATION_LIST = 'SET_ITEM_LOCATION_LIST';
export const GET_ITEM_LOCATION_LIST_IN_PROGRESS = 'GET_ITEM_LOCATION_LIST_IN_PROGRESS';
export const SAVE_ITEM_LOCATION = 'SAVE_ITEM_LOCATION';
export const DELETE_ITEM_LOCATION = 'DELETE_ITEM_LOCATION';
export const GET_ITEM_LOCATIONS = 'GET_ITEM_LOCATIONS';
export const GET_ITEM_LOCATION = 'GET_ITEM_LOCATION';
export const SET_MODAL_LOADING = 'SET_MODAL_LOADING';
export const SET_ITEM_LOCATIONS_PAGINATION = 'SET_ITEM_LOCATIONS_PAGINATION';
export const INITIALIZE_DEFAULT_ITEM_LOCATION = 'INITIALIZE_DEFAULT_ITEM_LOCATION';


export const SET_MATRIX_CHILDREN = 'SET_MATRIX_CHILDREN';
export const SET_MATRIX_CHILD_PAGINATION = 'SET_MATRIX_CHILD_PAGINATION';
export const APPLY_TO_ALL_ITEM_LOCATION = 'APPLY_TO_ALL_ITEM_LOCATION';


export const GET_ENTITY_PURCHASE_ORDERS = 'GET_ENTITY_PURCHASE_ORDERS';
export const GET_ENTITY_PURCHASE_ORDERS_IN_PROGRESS = 'GET_ENTITY_PURCHASE_ORDERS_IN_PROGRESS';
export const SET_ENTITY_PURCHASE_ORDER_LIST = 'SET_ENTITY_PURCHASE_ORDER_LIST';
export const SET_ENTITY_PURCHASE_ORDER_PAGINATION = 'SET_ENTITY_PURCHASE_ORDER_PAGINATION';

export const GET_ENTITY_PURCHASE_RECEIPTS = 'GET_ENTITY_PURCHASE_RECEIPTS';
export const GET_ENTITY_PURCHASE_RECEIPTS_IN_PROGRESS = 'GET_ENTITY_PURCHASE_RECEIPTS_IN_PROGRESS';
export const SET_ENTITY_PURCHASE_RECEIPT_LIST = 'SET_ENTITY_PURCHASE_RECEIPT_LIST';
export const SET_ENTITY_PURCHASE_RECEIPT_PAGINATION = 'SET_ENTITY_PURCHASE_RECEIPT_PAGINATION';

export const GET_ENTITY_INVENTORY_RETURN = 'GET_ENTITY_INVENTORY_RETURN_LIST';
export const GET_ENTITY_INVENTORY_RETURN_IN_PROGRESS = 'GET_ENTITY_INVENTORY_RETURN_IN_PROGRESS';
export const SET_ENTITY_INVENTORY_RETURN_LIST = 'SET_ENTITY_INVENTORY_RETURN_LIST';
export const SET_ENTITY_INVENTORY_RETURN_PAGINATION = 'SET_ENTITY_INVENTORY_RETURN_PAGINATION';

export const INITIALIZE_SUMMARY_TYPE = 'INITIALIZE_SUMMARY_TYPE';
export const FETCHING_SUMMARY_TYPE = 'FETCHING_SUMMARY_TYPE';
export const SUCCESS_FETCHING_SUMMARY_TYPE = 'SUCCESS_FETCHING_SUMMARY_TYPE';
export const ERROR_FETCHING_SUMMARY_TYPE = 'ERROR_FETCHING_SUMMARY_TYPE';
export const QUERY_SUMMARIES = 'QUERY_SUMMARIES';
export const FETCH_SUMMARY_TYPE_DATA = 'FETCH_SUMMARY_TYPE_DATA';
export const EXPORT_STORE_SUMMARY_TO_DOC = 'EXPORT_STORE_SUMMARY_TO_DOC';

export const IMPORT_FROM_DOC = 'IMPORT_FROM_DOC';

export const CLEAR_EMPLOYEE = 'CLEAR_EMPLOYEE';
export const EMPLOYEE_REGISTERPIN_CHANGED = 'EMPLOYEE_REGISTERPIN_CHANGED';
export const EMPLOYEE_PASSWORD_RESET_SENT = 'EMPLOYEE_PASSWORD_RESET_SENT';

export const SET_CUSTOM_FORM_ERROR = 'SET_CUSTOM_FORM_ERROR';
export const SET_CUSTOM_FORM_DATA = 'SET_CUSTOM_FORM_DATA';
export const GET_CUSTOM_FORM_DATA = 'GET_CUSTOM_FORM_DATA';
export const CUSTOM_FORM_SET_LOADING = 'CUSTOM_FORM_SET_LOADING';
export const CUSTOM_FORM_SET_LOADING_DONE = 'CUSTOM_FORM_SET_LOADING_DONE';

export const ADD_RECORD_FIELD = 'ADD_RECORD_FIELD';

export const OPEN_ITEM_UOM_MODAL = 'OPEN_ITEM_UOM_MODAL';
export const CLOSE_ITEM_UOM_MODAL = 'CLOSE_ITEM_UOM_MODAL';
export const SET_ITEM_UOM = 'SET_ITEM_UOM';
export const CLEAR_ITEM_UOM = 'CLEAR_ITEM_UOM';
export const VIEW_ITEM_UOM_MODAL = 'VIEW_ITEM_UOM_MODAL';
export const EDIT_ITEM_UOM_MODAL = 'EDIT_ITEM_UOM_MODAL';
export const SAVE_ITEM_UOM = 'SAVE_ITEM_UOM';
export const DELETE_ITEM_UOM = 'DELETE_ITEM_UOM';
export const GET_ITEM_UOMS = 'GET_ITEM_UOMS';
export const GET_ITEM_UOM = 'GET_ITEM_UOM';
export const SET_ITEM_UOMS_PAGINATION = 'SET_ITEM_UOMS_PAGINATION';
export const GET_ITEM_UOM_LIST_IN_PROGRESS = 'GET_ITEM_UOM_LIST_IN_PROGRESS';
export const SET_ITEM_UOM_LIST = 'SET_ITEM_UOM_LIST';

export const IS_LOADING_PREVIEW = 'IS_LOADING_PREVIEW';
export const IS_DONE_LOADING_PREVIEW = 'IS_DONE_LOADING_PREVIEW';
export const IS_ERROR_LOADING_PREVIEW = 'IS_ERROR_LOADING_PREVIEW';

export const ERECEIPT_CONTACTS_FETCHING = 'ERECEIPT_CONTACTS_FETCHING';
export const ERECEIPT_CONTACTS_FETCHING_DONE = 'ERECEIPT_CONTACTS_FETCHING_DONE';
export const ERECEIPT_LINK_SEND = 'ERECEIPT_LINK_SEND';
export const ERECEIPT_LINK_SEND_ERROR_CLEAR = 'ERECEIPT_LINK_SEND_ERROR_CLEAR';
export const ERECEIPT_LINK_SENDING = 'ERECEIPT_LINK_SENDING';
export const ERECEIPT_LINK_SENDING_FAILED = 'ERECEIPT_LINK_SENDING_FAILED';
export const ERECEIPT_LINK_SENDING_SUCCESS = 'ERECEIPT_LINK_SENDING_SUCCESS';
export const ERECEIPT_MODAL_HIDE = 'ERECEIPT_MODAL_HIDE';
export const ERECEIPT_MODAL_RESET = 'ERECEIPT_MODAL_RESET';
export const ERECEIPT_MODAL_SHOW = 'ERECEIPT_MODAL_SHOW';
export const ERECEIPT_MODAL_TOGGLE = 'ERECEIPT_MODAL_TOGGLE';
export const ERECEIPT_SALE = 'ERECEIPT_SALE';

export const COMMON_PROMPT_MODAL_SHOW = 'COMMON_PROMPT_MODAL_SHOW';
export const COMMON_PROMPT_MODAL_HIDE = 'COMMON_PROMPT_MODAL_HIDE';
export const COMMON_PROMPT_MODAL_SIGNAL = 'COMMON_PROMPT_MODAL_SIGNAL';

export const FETCH_EMPLOYEE_ROLE_AUTHORITY_LIST = 'FETCH_EMPLOYEE_ROLE_AUTHORITY_LIST';
export const SET_USER_ROLE_AUTHORITY_LIST = 'SET_USER_ROLE_AUTHORITY_LIST';

export const FETCH_SYSTEM_NOTES_INPROGRESS = 'FETCH_SYSTEM_NOTES_INPROGRESS';
export const FETCH_SYSTEM_NOTES_DONE = 'FETCH_SYSTEM_NOTES_DONE';
export const FETCH_SYSTEM_NOTES_ERROR = 'FETCH_SYSTEM_NOTES_ERROR';

export const FETCH_ADDRESS_TYPE_LIST = 'FETCH_ADDRESS_TYPE_LIST';
export const SET_ADDRESS_TYPE_LIST = 'SET_ADDRESS_TYPE_LIST';

export const FETCH_COUNTRY_LIST = 'FETCH_COUNTRY_LIST';
export const SET_COUNTRY_LIST = 'SET_COUNTRY_LIST';

export const SET_SALE_TRANSACTION_INVENTORY = 'SET_SALE_TRANSACTION_INVENTORY';
